<template>
  <div class="ribbons left ribbon-holder" id="ribbon-9">
    <span class="ribbon" :class="type"><span class="text">{{text}}</span></span>
  </div>
</template>
<script>
  export default{
    name: "lms-ribbon",
    props: {
      text: {},
      type: {}
    }
  }
</script>
<style>
  .ribbon-holder {
    position: relative;
  }

  .ribbon-holder {
    position: absolute;
    top: 0;
    overflow: hidden;
    height: 100px;
    font-size: 12px;
  }

  .left.ribbon-holder {
    left: 0;
  }

  .ribbon-holder .ribbon,
  .ribbon-holder .ribbon:hover {
    text-decoration: none;
  }

  .ribbon-holder .ribbon {
    font-family: Collegiate, sans-serif;
    letter-spacing: -.1px;
    opacity: 0.95;
    padding: 0.25em 0;
    position: relative;
    top: 1.2em;
    box-shadow: 0 0 13px #888;
    color: #FFF;
    display: block;
    line-height: 1.35em;
  }

  .ribbon-holder .ribbon .text {
    padding: 0.1em 3em;
  }

  .left .ribbon {
    -moz-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
    left: -1.82em;
  }

  .red.ribbon {
    background-color: #9a0000;
    background-image: linear-gradient(bottom, #9a0000, #a90000);
    background-image: -o-linear-gradient(bottom, #9a0000, #a90000);
    background-image: -moz-linear-gradient(bottom, #9a0000, #a90000);
    background-image: -webkit-linear-gradient(bottom, #9a0000, #a90000);
    background-image: -ms-linear-gradient(bottom, #9a0000, #a90000);
    background-image: -webkit-gradient(
      linear,
      left bottom,
      left top,
      color-stop(#9a0000),
      color-stop(#a90000)
    );
  }

  .red.ribbon .text {
    border: 1px solid #bf6060;
  }

  .green.ribbon {
    background-color: #19be6b;
    background-image: linear-gradient(bottom, #19be6b, #91be6b);
    background-image: -o-linear-gradient(bottom, #19be6b, #91be6b);
    background-image: -moz-linear-gradient(bottom, #19be6b, #91be6b);
    background-image: -webkit-linear-gradient(bottom, #19be6b, #91be6b);
    background-image: -ms-linear-gradient(bottom, #19be6b, #91be6b);
    background-image: -webkit-gradient(
      linear,
      left bottom,
      left top,
      color-stop(#19be6b),
      color-stop(#91be6b)
    );
  }

  .green.ribbon .text {
    border: 1px solid #19be6b;
  }
</style>



// WEBPACK FOOTER //
// Ribbon.vue?384840de